import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table } from "antd";
import { goPage } from "../../layout/pageDefinition";
import { useModel } from "../../../models";
import { formatNum } from "../../../utils/constants";
import moment from "moment";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        render: (text, record, index) => `${index + 1}`,
    },
    {
        title: '退货单号',
        width: 160,
        dataIndex: 'returnCode',
        align: 'left',
    },
    {
        title: '退货状态',
        width: 100,
        dataIndex: 'orderStatusName',
    },
    {
        title: '支付状态',
        width: 100,
        dataIndex: 'paymentStatusName',
    },
    {
        title: '客户',
        width: 160,
        ellipsis: true,
        dataIndex: 'customerName',
    },
    {
        title: '退货数量',
        width: 80,
        dataIndex: 'returnNum',
    },
    {
        title: '优惠总金额',
        width: 100,
        dataIndex: 'discountAmount',
    },
    {
        title: '应付金额',
        width: 80,
        dataIndex: 'payableAmount',
        render: text => formatNum(text)
    },
    {
        title: '已付金额',
        width: 80,
        dataIndex: 'paidAmount',
    },
    {
        title: '发票类型',
        width: 120,
        dataIndex: 'invoiceTypeName',
    },
    {
        title: '客户编码',
        width: 160,
        dataIndex: 'customerCode',
    },
    {
        title: '联系人',
        width: 100,
        dataIndex: 'customerPerson',
    },
    {
        title: '电话',
        width: 100,
        dataIndex: 'customerPhone',
    },
    {
        title: '业务员',
        width: 100,
        dataIndex: 'createUser',
    },
    /*{
        title: '公司',
        width: 160,
        ellipsis: true,
        dataIndex: 'orgId',
    },*/
    {
        title: '退货日期',
        width: 100,
        dataIndex: 'returnTime',
        render: text => text ? moment(text).format("YYYY-MM-DD") : ""
    },
    {
        title: '制单日期',
        width: 160,
        dataIndex: 'createTime',
    },
    {
        title: '备注',
        width: 200,
        dataIndex: 'returnDesc',
    }
];


export default function () {
    const [
        {
            searchParam,
            documentList,
            documentStatistic,
            documentPageInfo,
            selectedDocumentRowKeys
        }, {
            loadDocumentList,
            setSelectedDocumentRowKeys,
            exportRo,
            setDocumentMaterialList,
            loadRo,
            setSelectedDocument,
            setFormData
        }
    ] = useModel("saleRo");
    useEffect(() => {
        const [startTime = null, endTime = null] = !!searchParam["startEndDate"] ? searchParam["startEndDate"] : [];
        const { pageSize, pageNum } = documentPageInfo;
        const { returnCode, customerId, orderStatus } = searchParam;
        let data = {
            pageSize,
            pageNum,
            startTime,
            endTime,
            returnCode,
            customerId,
            orderStatus,
        }
        loadDocumentList({ showMsg: false, data });
    }, []);
    const TableHeader = () => {
        const history = useHistory();
        const onAdd = () => {
            setSelectedDocument({});
            setDocumentMaterialList([]);
            setFormData({});
            goPage(history, "3-3-2");
        }
        const onEdit = () => {
            setFormData({});
            loadRo({ showMsg: false, data: selectedDocumentRowKeys[0] }).then(() => {
                goPage(history, "3-3-1");
            });
        }
        const onExport = () => {
            const { returnCode, customerId, orderStatus, startEndDate } = searchParam;
            const [startTime = null, endTime = null] = !!startEndDate ? startEndDate : [];
            const { pageSize, pageNum } = documentPageInfo;
            let data = {
                pageSize,
                pageNum,
                startTime,
                endTime,
                returnCode,
                customerId,
                orderStatus,
            }
            exportRo({ showMsg: true, data })
        }

        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.SR_AD}>
                        <Button type="primary" onClick={onAdd}>新增</Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SR_ED}>
                        <Button
                            className="margin-left-8"
                            onClick={onEdit}
                            disabled={!(selectedDocumentRowKeys.length > 0)}
                        >
                            {
                                (
                                    selectedDocumentRowKeys.length === 1
                                    && documentList.find(el => el.key === selectedDocumentRowKeys[0])
                                    && documentList.find(el => el.key === selectedDocumentRowKeys[0]).orderStatus === "029004"
                                ) ? "查看" : "编辑"
                            }
                        </Button>
                    </YhAuth>
                    <YhAuth resCode={ResourceAuthEnum.SR_EXPORT}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span
                        className="margin-left-8">
                        退货总数量：{!!documentStatistic ? documentStatistic.returnNumTotal : 0}</span>
                    <span
                        className="margin-left-16">
                        应付总金额：{!!documentStatistic ? documentStatistic.returnAmountTotal : 0.00}</span>
                    <span
                        className="margin-left-16">
                        已付总金额：{!!documentStatistic ? documentStatistic.paidAmountTotal : 0.00}</span>
                    <span
                        className="margin-left-16">
                        退货成本：{!!documentStatistic ? documentStatistic.sreturnCostTotal : 0.00}</span>
                    <span
                        className="margin-left-16">
                        退货毛利：{!!documentStatistic ? documentStatistic.sreturnProfitTotal : 0.00}</span>
                </div>
            </div>
        )
    }

    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={documentList}
                bordered
                pagination={{
                    hideOnSinglePage: false,
                    showSizeChanger: true,
                    pageSizeOptions: [15, 50, 100, 200, 500],
                    defaultCurrent: 1,
                    defaultPageSize: 15,
                    onChange: (pageNum, pageSize) => {
                        const { returnCode, customerId, orderStatus, startEndDate } = searchParam;
                        const [startTime = null, endTime = null] = !!startEndDate ? startEndDate : [];
                        let data = {
                            pageSize,
                            pageNum,
                            startTime,
                            endTime,
                            returnCode,
                            customerId,
                            orderStatus,
                        }
                        loadDocumentList({ showMsg: false, data });
                    },
                    total: documentPageInfo.total,
                    current: documentPageInfo.pageNum,
                }}
                onRow={record => {
                    return {
                        onClick: event => {
                            if (selectedDocumentRowKeys.length > 0 && selectedDocumentRowKeys[0] === record.key) {
                                setSelectedDocumentRowKeys([]);
                            } else {
                                setSelectedDocumentRowKeys([record.key]);
                            }
                        },
                    };
                }}
                rowSelection={{
                    type: "radio",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setSelectedDocumentRowKeys(selectedRowKeys);
                    },
                    selectedRowKeys: selectedDocumentRowKeys
                }}
                scroll={{ x: 'max-content', y: 600 }}
            />
        </>
    );
}